import React from "react";
import { TrendingUp, Target, Brain, Users, BarChart3, Zap } from "lucide-react";

const benefits = [
  {
    title: "Smart Home Hunting",
    description:
      "Learn the insider secrets to finding great homes before they hit the market",
  },
  {
    title: "Mortgage Mastery",
    description:
      "Discover how to get the best rates and terms, even with less-than-perfect credit",
  },
  {
    title: "Negotiation Tactics",
    description:
      "Win bidding wars and negotiate below asking price in any market condition",
  },
  {
    title: "Inspection Insights",
    description: "Spot red flags that could cost you thousands after closing",
  },
  {
    title: "First-Time Buyer Programs",
    description:
      "Access hidden programs that can save you $10,000+ on your purchase",
  },
  {
    title: "Closing Confidence",
    description:
      "Navigate the closing process like a pro and avoid last-minute surprises",
  },
];

export const WebinarBenefits = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-2 sm:px-4 max-w-full">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-xl sm:text-2xl lg:text-4xl font-bold mb-3 sm:mb-4 lg:mb-6 text-gray-900 px-2">
            What You'll Learn in This
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
              Home Buyer's Masterclass
            </span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
            This isn't your typical webinar. We're sharing the insider
            strategies that help first-time buyers get their dream home for the
            best price.
          </p>
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mx-2">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-white to-gray-50 hover:from-white hover:to-purple-50 border border-gray-200/50 rounded-lg sm:rounded-xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2 p-4 sm:p-6 lg:p-8">
              <div className="flex items-start sm:items-center mb-3 sm:mb-4">
                <div className="p-2 sm:p-3 rounded-lg bg-gradient-to-r from-purple-600 to-pink-600 mr-3 sm:mr-4 group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                  {index === 0 && (
                    <TrendingUp className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-white" />
                  )}
                  {index === 1 && (
                    <Target className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-white" />
                  )}
                  {index === 2 && (
                    <Brain className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-white" />
                  )}
                  {index === 3 && (
                    <Users className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-white" />
                  )}
                  {index === 4 && (
                    <BarChart3 className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-white" />
                  )}
                  {index === 5 && (
                    <Zap className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-white" />
                  )}
                </div>
                <h3 className="text-base sm:text-lg lg:text-xl font-semibold text-gray-900 mb-1 sm:mb-2">
                  {benefit.title}
                </h3>
              </div>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WebinarBenefits;
